import React from 'react';
import {slugify, generateCdnAssetsUrl} from '../utils/helpers';

interface IProps {
  regionName: string;
  className?: string,
}

interface IState {
  wasError: boolean,
}

class CountryFlag extends React.Component<IProps> {
  public readonly state: IState = {
    wasError: false,
  };

  getImageSrc(): string {
    return generateCdnAssetsUrl(`flags/${slugify(this.props.regionName)}.svg`);
  }

  getDefaultFlagUrl() {
    return generateCdnAssetsUrl(`flags/default.svg`);
  }

  getClassName() {
    if (this.props.className) {
      return this.props.className
    } else {
      return ''
    }
  }

  render() {
    const { wasError } = this.state;
    return (
      <img
        className={this.getClassName()}
        src={this.getImageSrc()}
        alt={this.props.regionName}
        onError={(e: any) => {
          if (!wasError) {
            e.target.onerror = null
            e.target.src = this.getDefaultFlagUrl()
            this.setState({
              wasError: true,
            })
          }
        }}
      />
    )
  }
}

export default CountryFlag;
